var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.5433 11.4771C75.1543 5.31856 84.8457 5.31856 90.4567 11.4771C94.1789 15.5625 99.9395 17.106 105.206 15.429C113.144 12.9011 121.537 17.7468 123.317 25.8858C124.498 31.2849 128.715 35.5019 134.114 36.6828C142.253 38.4628 147.099 46.8558 144.571 54.7943C142.894 60.0605 144.438 65.8211 148.523 69.5433C154.681 75.1543 154.681 84.8457 148.523 90.4567C144.438 94.1789 142.894 99.9395 144.571 105.206C147.099 113.144 142.253 121.537 134.114 123.317C128.715 124.498 124.498 128.715 123.317 134.114C121.537 142.253 113.144 147.099 105.206 144.571C99.9395 142.894 94.1789 144.438 90.4567 148.523C84.8457 154.681 75.1543 154.681 69.5433 148.523C65.8211 144.438 60.0605 142.894 54.7943 144.571C46.8558 147.099 38.4628 142.253 36.6828 134.114C35.5019 128.715 31.2849 124.498 25.8858 123.317C17.7468 121.537 12.9011 113.144 15.429 105.206C17.106 99.9395 15.5625 94.1789 11.4771 90.4567C5.31856 84.8457 5.31856 75.1543 11.4771 69.5433C15.5625 65.8211 17.106 60.0605 15.429 54.7943C12.9011 46.8558 17.7468 38.4628 25.8858 36.6828C31.2849 35.5019 35.5019 31.2849 36.6828 25.8858C38.4628 17.7468 46.8558 12.9011 54.7943 15.429C60.0605 17.106 65.8211 15.5625 69.5433 11.4771Z",
    fill: "#FF7FFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80 112C97.6731 112 112 97.6731 112 80C112 62.3269 97.6731 48 80 48C62.3269 48 48 62.3269 48 80C48 97.6731 62.3269 112 80 112Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80 82.6182C81.446 82.6182 82.6182 81.446 82.6182 80C82.6182 78.554 81.446 77.3818 80 77.3818C78.554 77.3818 77.3818 78.554 77.3818 80C77.3818 81.446 78.554 82.6182 80 82.6182Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0364 93.9634L73.7746 73.7743L93.9636 66.0361L86.2255 86.2252L66.0364 93.9634Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Svg);
export default __webpack_public_path__ + "static/media/1_svg.4ad91a5d02872d51bb9d76594853b08a.svg";
export { ForwardRef as ReactComponent };